/* eslint-disable react/no-unknown-property */
/* eslint-disable prettier/prettier */
/** @jsx jsx */
import { Box, jsx, Text } from 'theme-ui';
import InnerPage from './InnerPage';
// import NewSolarSystem from './NewSolarSystem';
// import NewSolarSystem from './NewSolarSystem';
// import Rings from './Rings';
// import SolarSystem from './SolarSystem';

function Hero() {
  return (
    <Box
      // variant="styles.plateHero"
      sx={
        {
          // borderBottomColor: `grays.4`,
          // // maxWidth: [`90vw`, `80vw`, `93vw`],
          // // marginLeft: [`auto`, `auto`, `auto`],
          // ml: [4, 0, 7],
          // mt: [6, 0, 0],
          // marginRight: [`0px`, `0px`, `0px`],
          // px: [0, 4, 0],
          // pt: [0, 0, 7],
          // display: `flex`,
          // alignItems: `center`,
          // justifyContent: `space-between`,
          // flexWrap: `wrap`,
          // overflow: `hidden`,
        }
      }
    >
      <InnerPage>
        <Box
          sx={{
            minHeight: [`50vh`, `73vh`, `45vh`],
            // position: [`absolute`, `relative`, `relative`],
            bottom: 0,
          }}
        >
          <Text as="h1" variant="heroTitle" sx={{ mb: [3] }}>
            Launch Incredible Products
          </Text>
          <Box>
            <Text
              as="h2"
              variant="heroDesc"
              sx={{ color: `dimText2`, lineHeight: `body`, mb: [0], mt: 0 }}
            >
              As a Product studio, we help product companies fasten up.
            </Text>

            {/* <Link
            target="_blank"
            rel="noopener noreferrer"
            to="https://calendly.com/muneef/15min"
          >
            <Text
              as="span"
              variant="btnLink"
              sx={{
                display: `block`,
                width: `12ch`,
                fontSize: 2,
                color: `grays.8`,
                fontWeight: `bold`,
                pb: 2,
                mt: 5,
                borderBottom: `solid 2px`,
                borderBottomColor: `blue.7`,
                '&:hover': {
                  color: `blue.7`,
                }
              }}
            >
              Schedule a Call
            </Text>
          </Link> */}

            {/* <Text
            as="span"
            sx={{
              pt: 3,
              pb: 2,
              width: `40%`,
              display: `block`,
              fontSize: 1,
              fontWeight: `bold`,
              borderBottom: `solid 1px`,
              borderColor: `blue.8`,
            }}
          >
            Explore our Services
          </Text> */}
          </Box>
        </Box>
      </InnerPage>
    </Box>
  );
}

export default Hero;
